import { Navigate } from 'react-router-dom';

import { useAuth } from '../lib/auth/AuthProvider';
import { homePathFor } from '../lib/home';
import { IS_NATIVE } from '../lib/base';
import { LandingPage } from '../pages/LandingPage';

/**
 * Ruta raíz ("/") pública.
 *
 * - Visitante SIN sesión → landing pública (home del sitio).
 * - Mientras se bootea la sesión ('loading') → también mostramos la landing:
 *   no queremos bloquear la home tras un spinner ni exigir auth. Si el bootstrap
 *   resuelve a "autenticado", el re-render redirige enseguida.
 * - Usuario autenticado → su dashboard: super admin a /admin, empresa a /inicio.
 *
 * En la app NATIVA (Capacitor) no existe la landing de marketing: el punto de
 * entrada es el login. Por eso, si no hay sesión (o mientras bootea), redirigimos
 * a /login en vez de renderizar la landing. Autenticado sigue yendo al dashboard.
 */
export function RootRoute() {
  const { status, user } = useAuth();

  if (status === 'authenticated') {
    // Página de inicio según la preferencia del usuario (super admin → /admin).
    return <Navigate to={homePathFor(user)} replace />;
  }

  if (IS_NATIVE) return <Navigate to="/login" replace />;

  return <LandingPage />;
}
